import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import iconFacebook from '../images/icons/face-icon.png'

const SelectLanguage = props => {
  return (
    <div className="languages">
      <ul>
        <li>
          <Link to={'/en/terms_conditions'}>
            
            Terms And Conditions
          </Link>
        </li>
        {props.langs.map(
          lang =>
            lang.langKey == 'es' ? (
              <li
                key={lang.langKey}
                className={lang.selected ? 'current-lang' : null}
              >
                <Link to={lang.link} key={lang.langKey}>
                  Español
                </Link>
              </li>
              
            ) : (
              ""
            )
        )}
        <li style= {{margin:'-40px 20px 0 0'}} ><a
          href="https://www.facebook.com/budgetnicaragua/"
          target="_blank"
        >
          <img src={iconFacebook} alt="" />
        </a>
        </li>
      </ul>
    
    </div>
 

  )
}

SelectLanguage.propTypes = {
  langs: PropTypes.array,
}

export default SelectLanguage



// WEBPACK FOOTER //
// ./src/components/SelectLanguage.js